import { c as _c } from "react/compiler-runtime";
import { useI18n } from '@/context/I18nProvider';
import { AlertTriangle, Info, X } from '@/components';
import { useTopBar, TopBarNotificationType } from '@/context/TopBarContext';
import { cn } from '@/lib/utils';
import Link from 'next/link';
const typeStyles: Record<TopBarNotificationType, {
  bg: string;
  text: string;
  icon: string;
  border: string;
  link: string;
}> = {
  error: {
    bg: 'bg-red-50',
    text: 'text-red-800',
    icon: 'text-red-500',
    border: 'border-red-200',
    link: 'text-red-700 underline hover:text-red-900'
  },
  warning: {
    bg: 'bg-amber-50',
    text: 'text-amber-800',
    icon: 'text-amber-500',
    border: 'border-amber-200',
    link: 'text-amber-700 underline hover:text-amber-900'
  },
  info: {
    bg: 'bg-blue-50',
    text: 'text-blue-800',
    icon: 'text-blue-500',
    border: 'border-blue-200',
    link: 'text-blue-700 underline hover:text-blue-900'
  }
};
const TypeIcon = t0 => {
  const $ = _c(8);
  const {
    type
  } = t0;
  const style = typeStyles[type];
  let t1;
  if ($[0] !== style.icon) {
    t1 = cn("h-4 w-4 shrink-0", style.icon);
    $[0] = style.icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const className = t1;
  switch (type) {
    case "error":
      {
        let t2;
        if ($[2] !== className) {
          t2 = <AlertTriangle className={className} />;
          $[2] = className;
          $[3] = t2;
        } else {
          t2 = $[3];
        }
        return t2;
      }
    case "warning":
      {
        let t2;
        if ($[4] !== className) {
          t2 = <AlertTriangle className={className} />;
          $[4] = className;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        return t2;
      }
    case "info":
      {
        let t2;
        if ($[6] !== className) {
          t2 = <Info className={className} />;
          $[6] = className;
          $[7] = t2;
        } else {
          t2 = $[7];
        }
        return t2;
      }
  }
};
const TopBar = () => {
  const $ = _c(11);
  const {
    visibleNotifications,
    queuedCount,
    dismissNotification
  } = useTopBar();
  const {
    t
  } = useI18n();
  if (visibleNotifications.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== dismissNotification || $[1] !== visibleNotifications) {
    let t1;
    if ($[3] !== dismissNotification) {
      t1 = notification => {
        const style = typeStyles[notification.type];
        return <div key={notification.id} className={cn("flex items-center justify-between gap-3 rounded-lg border px-4 py-2 text-sm font-medium transition-all animate-in fade-in slide-in-from-top-1 duration-200", style.bg, style.text, style.border)}><div className="flex items-center gap-2 min-w-0"><TypeIcon type={notification.type} /><span className="truncate">{notification.message}</span>{notification.link && <Link href={notification.link.href} className={cn("shrink-0 whitespace-nowrap text-sm font-semibold", style.link)}>{notification.link.label}</Link>}</div><button onClick={() => dismissNotification(notification.id)} className={cn("shrink-0 rounded-md p-0.5 transition-colors hover:bg-black/5", style.text)} aria-label="Dismiss notification"><X className="h-4 w-4" /></button></div>;
      };
      $[3] = dismissNotification;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = visibleNotifications.map(t1);
    $[0] = dismissNotification;
    $[1] = visibleNotifications;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[5] !== queuedCount || $[6] !== t) {
    t1 = queuedCount > 0 && <p className="text-xs text-muted-foreground text-center">{t("topbar.moreNotifications", {
        count: queuedCount
      })}</p>;
    $[5] = queuedCount;
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t0 || $[9] !== t1) {
    t2 = <div className="flex flex-col gap-1.5">{t0}{t1}</div>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export { TopBar };